import angular from 'angular';
import {
    IContribuinteIndividual,
    IContribuinteIndividualCreate,
    IContribuinteIndividualGet
} from './model/contribuintesindividuais.model';
import { LoadParams } from '../../../shared/models/loadparams.model';

export class MeurhContribuintesIndividuaisService {
    static $inject = ['$http', '$rootScope', '$q', 'nsjRouting'];

    public loading_deferred: angular.IDeferred<unknown>;
    public loadParams = new LoadParams();

    constructor(
        public $http: angular.IHttpService,
        public $rootScope: angular.IScope,
        public $q: angular.IQService,
        public nsjRouting: any,
    ) {}

    getContratacoesContribuinte(filter?: { situacao?: string }) {
        this.loadParams = {
            ...this.loadParams,
            finished: false,
            busy: true
        };
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IContribuinteIndividual[]>, reject) => {
            this.$http.get<IContribuinteIndividual[]>(
                this.nsjRouting.generate('meurh_solicitacoescontratacaocontribuinte_index', {
                    ...filter
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescontratacaocontribuinte_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                reject(response);
            })
            .finally(() => {
                this.loadParams = {
                    ...this.loadParams,
                    finished: true,
                    busy: false
                };
            });
        });
    }

    getContratacaoContribuinte(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IContribuinteIndividualGet>((resolve, reject) => {
            this.$http.get<IContribuinteIndividualGet>(
                this.nsjRouting.generate('meurh_solicitacoescontratacaocontribuinte_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescontratacaocontribuinte_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => reject(response));
        });
    }

    createContratacaoContribuinte(entity: IContribuinteIndividualCreate) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IContribuinteIndividualGet>, reject) => {
            this.$http.post<IContribuinteIndividualGet>(
                this.nsjRouting.generate('meurh_solicitacoescontratacaocontribuinte_create', {}, true), entity, {
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescontratacaocontribuinte_create_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescontratacaocontribuinte_create_error', response);
                reject(response);
            });
        });
    }
}
